<template>

    <div class="white-panel-items">

        <div class="wp-row" v-if="showCollection">
            <div class="flex-grids flex-item-middle">
                <div class="filter-title">{{ $t(dataSource.filter.title) }}:</div>
                <div class="flex-item-expand status-panel">
                    <v-chip-group active-class="active-panel-item" v-model="inputStatus" mandatory column>

                        <v-chip 
                            v-for="item in dataSource.filter.items"
                            :key="item.name"
                            :value="item.value"
                            class="ma-1"
                            small
                            label
                        >
                            {{ $t(item.name) }}
                            <span v-if="moreOrEqualZero(item.count)"> {{item.count}} </span>
                        </v-chip>

                    </v-chip-group>
                </div>
            </div>
        </div>

        <div v-if="hasItems && !!subFilter" class="wp-row">
            <div class="flex-grids flex-item-middle">
                <div class="filter-title">{{ $t(subFilter.title) }}:</div>
                <div class="flex-item-expand status-panel">
                    <v-chip-group 
                        v-model="inputSubstatus"
                        mandatory
                        column
                    >
                        <v-chip
                            v-for="item in subFilter.items"
                            :key="item.name"
                            :value="item.value"
                            :class="[item.value === inputSubstatus ? $options.filterValueClasses[inputSubstatus] ? $options.filterValueClasses[inputSubstatus] : 'active-panel-item' : '', 'ma-1']"
                            small
                            label
                        >
                            {{ $t(item.name) }}
                            <span v-if="moreOrEqualZero(item.count)"> {{item.count}} </span>
                        </v-chip>

                    </v-chip-group>
                </div>
            </div>
        </div>

        <div v-if="hasYears && !!yearFilter" class="wp-row">
            <div class="flex-grids flex-item-middle">
                <div class="filter-title">{{ $t(yearFilter.title) }}:</div>
                <div class="flex-item-expand status-panel">
                    <v-chip-group 
                        v-model="inputYear"
                        mandatory
                        column
                    >
                        <v-chip
                            v-for="item in yearFilter.items"
                            :key="item.name"
                            :value="item.value"
                            :class="[item.value === inputYear ? $options.filterValueClasses[inputYear] ? $options.filterValueClasses[inputYear] : 'active-panel-item' : '', 'ma-1']"
                            small
                            label
                        >
                            {{ $t(item.name) }}
                            <span v-if="moreOrEqualZero(item.count)"> {{item.count}} </span>
                        </v-chip>

                    </v-chip-group>
                </div>
            </div>
        </div>

        <slot>
           
        </slot>

    </div>

</template>

<script>
export default {
    name: "FilterPanel",
    filterValueClasses: {
        Today: 'today',
        Expired: 'expired',
        LessThan10Days: 'soon',
        MoreThan10Days: 'long-while',
        '30': 'today',
        '40': 'expired',
        ListToday: 'today',
        CalendarToday: 'today'
    },
    props: {
        status: {
            type: String,
            default: null
        },
        substatus: {
            type: String,
            default: null
        },
        year: {
            type: String,
            default: null
        },
        dataSource: {
            type: Object,
            default: null
        },
        showCollection: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
        }
    },
    computed: {
        hasItems () {
            let selected = this.dataSource.filter.items.find(x => x.value == this.inputStatus);
            return selected != null ? selected.hasItems : false;
        },
        subFilter () {
            return this.dataSource.filter.items.find(x => x.value == this.inputStatus).items;
        },
        hasYears() {
            let selected = this.subFilter?.items?.find(x => x.value == this.inputSubstatus);
            return selected != null ? selected.hasItems : false;
        },
        yearFilter(){
            return this.subFilter?.items?.find(x => x.value == this.inputSubstatus)?.items;
        },
        inputStatus:
        {
            get() {
                return this.status;
            },
            set(val) {
                this.$emit('update:status', val);
                let selected = this.dataSource.filter.items.find(x => x.value == val);

                let hasItems = selected?.hasItems ?? false;

                if (hasItems === false) {
                    this.$emit('update:substatus', selected?.items?.default);
                }
            }
        },
        inputSubstatus: {
            get() {
                return this.substatus;
            },
            set(val) {
                this.$emit('update:substatus', val);
            }
        },
        inputYear: {
            get() {
                return this.year;
            },
            set(val){
                this.$emit('update:year', val);
            }
        }
    },
    methods: {
        moreOrEqualZero (number) {
            if (typeof number !== 'number') return false;
            return number >= 0;
        }
    }
}
</script>

<style scoped>
    .today {
        background: #f57731;
        color: #fff!important;
    }
    .expired {
        background: #f04747;
        color: #fff!important;
    }
    .soon {
        background: #FAA61A;
        color: #fff!important;
    }
    .long-while {
        background: #43B581;
        color: #fff!important;
    }
</style>